import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CredentialsHelper = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const mockCredentials = [
    {
      role: "Business Owner",
      email: "owner@jewelthread.com",
      password: "JewelOwner123",
      description: "Full access to all features and team management"
    },
    {
      role: "Designer",
      email: "designer@jewelthread.com", 
      password: "Designer123",
      description: "Create projects and manage design assets"
    },
    {
      role: "Sales Representative",
      email: "sales@jewelthread.com",
      password: "Sales123", 
      description: "Client communication and project updates"
    }
  ];

  return (
    <div className="mt-8 p-4 bg-muted/30 rounded-lg border border-border">
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full justify-between"
      >
        <div className="flex items-center space-x-2">
          <Icon name="Info" size={16} />
          <span className="text-sm font-medium">Demo Credentials</span>
        </div>
        <Icon 
          name="ChevronDown" 
          size={16} 
          className={`transition-luxury ${isExpanded ? 'rotate-180' : ''}`} 
        />
      </Button>
      {isExpanded && (
        <div className="mt-4 space-y-3">
          <p className="text-xs text-muted-foreground">
            Use these credentials to explore different user roles:
          </p>
          
          {mockCredentials?.map((cred, index) => (
            <div key={index} className="p-3 bg-card rounded-lg border border-border">
              <div className="flex items-start justify-between mb-2">
                <div>
                  <h4 className="text-sm font-medium text-foreground">
                    {cred?.role}
                  </h4>
                  <p className="text-xs text-muted-foreground">
                    {cred?.description}
                  </p>
                </div>
              </div>
              
              <div className="space-y-1">
                <div className="flex items-center space-x-2">
                  <Icon name="Mail" size={12} />
                  <code className="text-xs font-data text-foreground bg-muted px-2 py-1 rounded">
                    {cred?.email}
                  </code>
                </div>
                <div className="flex items-center space-x-2">
                  <Icon name="Key" size={12} />
                  <code className="text-xs font-data text-foreground bg-muted px-2 py-1 rounded">
                    {cred?.password}
                  </code>
                </div>
              </div>
            </div>
          ))}
          
          <div className="flex items-center space-x-2 p-2 bg-warning/10 rounded border border-warning/20">
            <Icon name="AlertTriangle" size={14} color="var(--color-warning)" />
            <p className="text-xs text-warning">
              These are demo credentials for testing purposes only
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CredentialsHelper;